import { Button, Form, Select } from "antd";
import React, { useCallback, useEffect, useState } from "react";
import { jcTypeArray } from "../../utils";
import { authenticateToken } from "../../utils/auth";
import { responseNotification } from "../../utils/notify";
import { adminServices } from "../../utils/services";
const { Option, OptGroup } = Select;

const AddAdminServices = ({
  visibleData,
  services = [],
  onCloseMethod,
}: any) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [serviceData, setServiceData] = useState(undefined);
  const [error, setError] = useState("");

  const onSubmit = async (data: any) => {
    setLoading(true);

    const readyData = data && {
      serviceName: data.name,
      type: data.type,
    };

    if (serviceData) {
      await fetch(`${process.env.REACT_APP_AUTH_API}/service`, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${authenticateToken()}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          ...readyData,
          id: serviceData?.id,
          isActive: true,
        }),
      })
        .then((res) => res.json())
        .then((res) => {
          setLoading(false);

          if (res.statusCode === 200) {
            responseNotification("Service Updated Successfully", "success");
            form.resetFields();
            if (onCloseMethod) {
              onCloseMethod();
            }
          } else if (res.status === 500) {
            responseNotification("Internal server error", "error");
          } else {
            responseNotification(res.message || "something wrong", "warning");
          }
        })
        .catch((err) => {
          setLoading(false);
          responseNotification(`${"Internal server error"} ${err}`, "error");
          console.error("err", err);
        });
    } else {
      await fetch(`${process.env.REACT_APP_AUTH_API}/service`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${authenticateToken()}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(readyData),
      })
        .then((res) => res.json())
        .then((res) => {
          setLoading(false);

          if (res.statusCode === 200) {
            responseNotification("Service Create Successfully", "success");
            form.resetFields();
            if (onCloseMethod) {
              onCloseMethod();
            }
          } else if (res.status === 500) {
            responseNotification("Internal server error", "error");
          } else {
            responseNotification(res.message || "something wrong", "warning");
          }
        })
        .catch((err) => {
          setLoading(false);
          responseNotification(`${"Internal server error"} ${err}`, "error");
          console.error("err", err);
        });
    }
  };

  useEffect(() => {
    if (visibleData) {
      setServiceData(visibleData);
    }
  }, [visibleData]);

  useEffect(() => {
    if (serviceData) {
      form.resetFields();
    }
  }, [serviceData, visibleData]);

  const isExist = useCallback(
    (service: string | number) => {
      const hash = {} as any;

      services?.map((item: { name: string | number }) => {
        if (item?.name) {
          hash[item?.name] = item;
        }
        return true;
      });
      if (hash[service]) {
        return true;
      }
    },
    [services]
  );

  const filteredAdminServices = adminServices
    // eslint-disable-next-line array-callback-return
    ?.map((service) => {
      if (!service?.sub?.length) {
        if (!isExist(`${service?.name}`)) {
          return service;
        }
      } else {
        const subs = service?.sub?.filter(
          (item) => !isExist(`${service?.name} ${item?.name}`)
        );
        if (subs?.length) {
          return {
            ...service,
            sub: subs,
          };
        }
      }
    })
    ?.filter((item) => item);

  return (
    <div className="add-product drawer-toggle-wrapper">
      <Form
        name="control-hooks"
        labelCol={{ span: 24 }}
        wrapperCol={{ span: 24 }}
        className="ant-form ant-form-vertical"
        onFinish={onSubmit}
        form={form} // like ref
        layout="vertical"
        initialValues={{
          ...serviceData,
        }}
      >
        <Form.Item
          hasFeedback
          label="Service Name"
          rules={[
            {
              required: true,
              message: "Name is Required!",
            },
          ]}
          name="name"
        >
          {/* <Select placeholder="Services">
            {getAllServicesList().map((service, i) => {
              return (
                <Option value={service} key={i}>
                  {service}
                </Option>
              );
            })}
          </Select> */}
          <Select placeholder="Select Service">
            {filteredAdminServices?.flatMap((service, index) =>
              service?.sub ? (
                <OptGroup label={service?.name}>
                  {Object.values(
                    service?.sub.map((sub, i) => (
                      <Option
                        value={`${service?.name} ${sub?.name}`}
                        key={`${service?.name} ${sub?.name}`}
                      >
                        {sub?.name}
                      </Option>
                    ))
                  )}
                </OptGroup>
              ) : (
                <Option value={service?.name} key={index}>
                  {service?.name}
                </Option>
              )
            )}
          </Select>
        </Form.Item>

        <Form.Item
          hasFeedback
          label="Type"
          rules={[
            {
              required: true,
              message: "Type is required!",
            },
          ]}
          name="type"
          initialValue="JC_MART"
        >
          <Select placeholder="Service Type">
            {Object.values(jcTypeArray)?.map((type, i) => (
              <Select.Option value={type} key={i}>
                {type?.replace("_", " ")}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>

        <div className="buttons-container">
          <Button
            disabled={loading || !!error}
            loading={(loading ? "loading" : undefined) as any}
            type="primary"
            htmlType="submit"
            className="add-submit-btn text-center mr-2"
          >
            Submit
          </Button>
          <Button
            type="ghost"
            htmlType="button"
            onClick={() => {
              form?.resetFields();
            }}
            className="reset-submit-btn text-center mr-2"
          >
            Reset
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default AddAdminServices;
